module.exports = __webpack_public_path__ + "img/153.a0d743bb.svg";